import React, { memo } from 'react';
import { makeStyles } from '@material-ui/core';
import clsx from 'clsx';

const useStyles = makeStyles((theme) => ({
  dual__dialog: {
    position: 'fixed',
    zIndex: 999,
    left: 0,
    top: 0,
    width: '100%',
    height: '100%',
    overflow: 'auto',
    background: 'rgba(249, 250, 252, 0.6)',
    boxShadow: ' 0 8px 32px 0 rgba(31, 38, 135, 0.37)',
    backdropFilter: ' blur(30px)',
    display: 'none',
  },
  toggleDisplay: {
    display: 'block',
  },
  dual__dialog__container: {
    width: '80%',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%,-50%)',
    display: 'flex',
    boxSizing: 'border-box',
    overflow: 'hidden',
  },
  left__dialog: {
    height: '85vh',
    background: '#f6f8fa',
    border: '2px solid #ffffff',
    boxSizing: 'border-box',
    boxShadow: '0px 0px 40px rgb(38, 50, 56, 0.06)',
    borderRadius: '15px',
    animationDuration: '1s',
    width: '100%',
    overflow: 'hidden',
  },
  right__dialog: {
    height: '60vh',
    background: '#f6f8fa',
    border: '2px solid #ffffff',
    boxSizing: 'border-box',
    boxShadow: '0px 0px 40px rgb(38, 50, 56, 0.06)',
    borderRadius: '15px',
    animationDuration: '1s',
    transition: 'all 1s',
    transform: 'translate(-1rem,3.5rem)',
    width: '60%',
    overflow: 'hidden',
  },

  animate__cus: {
    animationName: 'animate__cus',
  },
  WD: {
    width: '90%',
    [theme.breakpoints.down('lg')]: {
      maxWidth: '90%',
    },
    [theme.breakpoints.down('md')]: {
      maxWidth: '80%',
    },
  },
  WS: {
    maxWidth: '60%',
    [theme.breakpoints.down('lg')]: {
      maxWidth: '60%',
    },
    [theme.breakpoints.down('md')]: {
      maxWidth: '50%',
    },
  },
  right__fields: {
    background: '#f6f8fa',
    border: '2px solid #ffffff',
    boxSizing: 'border-box',
    boxShadow: '0px 0px 40px rgb(38, 50, 56, 0.06)',
    borderRadius: '15px',
    position: 'absolute',
    width: '100%',
    right: '20px',
    top: '30px',
    animationName: 'animate__me',
    animationDuration: '1s',
  },
  popupp__heading: {
    fontSize: '20px',
    color: '#29264A',
    marginBottom: '30px',
    fontWeight: '600',
  },
  fields__container: {
    padding: '30px',
  },
  action__btns: {
    fontSize: '13px',
    borderRadius: '100px !important',
    height: '38px !important',
    width: '108px !important',
    fontWeight: '500 !important',
    textTransform: 'capitalize',
  },
  right__btn: {
    color: '#fff',
    background: '#6921C4 !important',
    marginLeft: '20px',
  },
  save__btn: {
    fontSize: '13px',
    borderRadius: '100px',
    height: '38px',
    width: 'max-content',
    minWidth: 'max-content',
    fontWeight: '500',
    textTransform: 'capitalize',
    justifyContent: 'flex-start',
    color: 'rgba(109, 125, 139, 0.8)',
    transition: '0.3s',
    background: 'transparent',
    '&:hover': {
      background: 'transparent',
      color: 'rgb(45, 68, 87)',
    },
    // background: 'rgba(105, 33, 196, 0.34) !important',
  },
  back__btn: {
    color: '#2D4457',
  },
  left__actions: {
    background: '#fff',
    boxShadow: '0 -12px 36px rgba(0, 0, 0, 0.04)',
    padding: '0 30px',
    height: '72px',
    alignSelf: 'flex-end',
  },
}));

const DualDialog = ({ toggle, children, showRight, isfromJobBoard }) => {
  const classes = useStyles();
  const [leftContent, rightContent] = children;

  return (
    <div
      className={clsx(classes.dual__dialog, toggle && classes.toggleDisplay)}
    >
      <div
        className={clsx(
          classes.dual__dialog__container,
          showRight ? classes.WD : isfromJobBoard ? classes.WD : classes.WS,
        )}
      >
        <div className={clsx(classes.left__dialog)}>{leftContent}</div>
        {showRight && (
          <div className={clsx(classes.right__dialog)}>{rightContent}</div>
        )}
      </div>
    </div>
  );
};
export default memo(DualDialog);
